<template lang="html">
  <section class="aDemo">

    <div style="width: 100%; margin-bottom: 32px;">
      <vlt-tabs>

        <vlt-tab label="Demo">
          <inapp-demo />
        </vlt-tab>

        <vlt-tab label="Guide">
          <inapp-guide />
        </vlt-tab>

      </vlt-tabs>
    </div>

  </section>

</template>

<script lang="js">
  import {
      VltTab,
      VltTabs,

  } from "@vonagevolta/vue";
  import Demo from './demo';
  import Guide from './guide';

  export default  {
    name: 'aDemo',
    components: {
        "vlt-tab": VltTab,
        "vlt-tabs": VltTabs,
        "inapp-demo": Demo,
        "inapp-guide": Guide,
    },
    props: {
      nexmo:{
          type: Object,
          required: false
      }
    },
    created() {
    }
}
</script>

<style scoped lang="scss">
</style>